import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: () => import('../views/home.vue')
}, {
  path: '/login',
  name: 'login',
  component: () => import('../views/login.vue')
}, {
  path: '/register',
  name: 'register',
  component: () => import('../views/register.vue')
}, {
  path: '/art',
  name: 'art',
  component: () => import('../views/art.vue')
}, {
  path: '/sport',
  name: 'sport',
  component: () => import('../views/sport.vue')
}, {
  path: '/science',
  name: 'science',
  component: () => import('../views/science.vue')
}, {
  path: '/success',
  name: 'success',
  component: () => import('../views/success.vue')
}, {
  path: '/forgotPassword',
  name: 'forgotPassword',
  component: () => import('../views/forgotPassword.vue')
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes
})

export default router
